/* eslint-disable */
require('./capital_1')
require('./capital_2')
require('./capital_3')
require('./corvette_1')
require('./corvette_1v2')
require('./corvette_1v3')
require('./corvette_2')
require('./corvette_2v2')
require('./corvette_2v3')
require('./corvette_3')
require('./corvette_3v2')
require('./corvette_3v3')
require('./energy_strikes')
require('./explosive_strikes')
require('./fighter_1')
require('./fighter_1v2')
require('./fighter_1v3')
require('./fighter_1v4')
require('./fighter_2')
require('./fighter_2v2')
require('./fighter_2v3')
require('./fighter_2v4')
require('./fighter_3')
require('./fighter_3v2')
require('./fighter_3v3')
require('./fighter_3v4')
require('./fighter_4')
require('./fighter_4v2')
require('./fighter_4v3')
require('./fighter_4v4')
require('./frame_ship_capital')
require('./frame_ship_corvette')
require('./frame_ship_fighter')
require('./frame_ship_frigate')
require('./frame_ship_hidden')
require('./frame_ship')
require('./frigate_1')
require('./frigate_1v2')
require('./frigate_2')
require('./frigate_2v2')
require('./frigate_3')
require('./frigate_3v2')
require('./frigate_4')
require('./frigate_4v2')
require('./handling')
require('./hull')
require('./interception')
require('./invasion')
require('./loot')
require('./raid')
require('./repair')
require('./shield')
require('./transport_1')
require('./transport_2')
require('./unit')
